/* ============================================================
   IRISHARP Virtual Try-On · Modal JS (Zenni-style)
   Two-screen flow:
     Screen 1: Privacy consent (white card)
     Screen 2: Camera AR (dark overlay, rail + lens tabs)
   Trigger: any element with [data-tryon-trigger]
   ============================================================ */
(function () {
  'use strict';

  // Bail if markup not present
  var root       = document.getElementById('tryonModal');
  if (!root) return;

  var consentEl  = root.querySelector('[data-tryon-screen="consent"]');
  var stageEl   = root.querySelector('[data-tryon-screen="stage"]');
  if (!consentEl || !stageEl) return;
  // ================================================================
  // EMBEDDED FRAME CATALOG (base64 data URIs — no CDN dependency)
  // ================================================================
  var EMBEDDED_FRAMES = [];


  // ---- Screen refs ----
  var agreeBtn   = consentEl.querySelector('[data-tryon-agree]');
  var backdrop   = root.querySelector('.tryon-modal__backdrop');
  var closeBtns  = root.querySelectorAll('[data-tryon-close]');

  // Stage
  var video      = document.getElementById('tryonModalVideo');
  var canvas     = document.getElementById('tryonModalCanvas');
  var ctx        = canvas ? canvas.getContext('2d') : null;
  var statusEl   = document.getElementById('tryonModalStatus');
  var statusTxt  = document.getElementById('tryonModalStatusText');
  var startOvl   = document.getElementById('tryonModalStartOverlay');
  var startBtn   = document.getElementById('tryonModalStartBtn');

  // Rail
  var railBtns   = stageEl.querySelectorAll('[data-tryon-action]');
  var pdPopover  = document.getElementById('tryonModalPdPopover');
  var pdValueEl  = document.getElementById('tryonModalPdValue');
  var pdSliderEl = document.getElementById('tryonModalPdSlider');
  var pdStatusEl = document.getElementById('tryonModalPdStatus');
  var pdResetEl  = document.getElementById('tryonModalPdReset');
  var pdCloseBtn = pdPopover ? pdPopover.querySelector('[data-tryon-close-pd]') : null;
  var adjustPopover = document.getElementById('tryonModalAdjustPopover');
  var adjustCloseBtn = adjustPopover ? adjustPopover.querySelector('[data-tryon-close-adjust]') : null;
  var sizeSliderEl = document.getElementById('tryonModalSizeSlider');
  var sizeValEl = document.getElementById('tryonModalSizeVal');
  var ySliderEl = document.getElementById('tryonModalYSlider');
  var yValEl = document.getElementById('tryonModalYVal');
  var xSliderEl = document.getElementById('tryonModalXSlider');
  var xValEl = document.getElementById('tryonModalXVal');
  var adjustResetBtn = document.getElementById('tryonModalAdjustReset');
  var photoInput = document.getElementById('tryonModalPhotoInput');
  var photoRailBtn = stageEl.querySelector('[data-tryon-action="upload"]');

  // Lens tabs
  var lensTabs   = stageEl.querySelectorAll('[data-lens]');

  // Lenses / Frames toggle
  var dockPills  = stageEl.querySelectorAll('[data-dock]');
  var frameSheet = document.getElementById('tryonModalFrameSheet');
  var frameGrid  = document.getElementById('tryonModalFrameGrid');
  var viewDetailsBtn = document.getElementById('tryonModalViewDetails');
  var colorSwatchesEl = document.getElementById('tryonModalColorSwatches');
  var colorSwatchesGrid = document.getElementById('tryonModalColorSwatchesGrid');

  // Debug
  var debugToggle = document.getElementById('tryonModalDebugToggle');
  var debugLog    = document.getElementById('tryonModalDebugLog');

  // ---- State ----
  var isOpen      = false;
  var screenState = 'consent'; // 'consent' | 'stage'
  var pdPopoverVisible = false;
  var adjustPopoverVisible = false;
  var frameSheetVisible = false;
  var activeLensType = 'clear';
  var activeDockTab  = 'lenses'; // 'lenses' | 'frames'
  var stream = null, faceMesh = null, detectRAF = null;
  var frameCount = 0, faceDetectedCount = 0;
  var defaultSize = parseFloat(sizeSliderEl && sizeSliderEl.value) || 3.0;
  var sizeMultiplier = defaultSize, yOffsetPct = 0, xOffsetPct = 0;
  var activeFrameKey = null;
  var measuredPD = 63.0, pdOverride = null;
  var frameCatalog = [];
  var currentFrame = { img: null, key: null, name: null };
  var frameChips = [];

  // Lens color overlays (RGBA)
  var LENS_COLORS = {
    'clear':           null,
    'sunglasses':      'rgba(30, 30, 30, 0.65)',
    'light-adjusting': 'rgba(100, 60, 200, 0.30)',
    'specialty':       'rgba(0, 100, 150, 0.40)'
  };
  var FACE_WIDTH_MM = 130;

  // ================================================================
  // Logging
  // ================================================================
  function log(msg, level) {
    if (!debugLog) return;
    level = level || '';
    var ts = new Date().toLocaleTimeString('en-GB', { hour12: false });
    var span = document.createElement('span');
    span.className = 'tryon-modal__line' + (level ? ' tryon-modal__line--' + level : '');
    span.textContent = '[' + ts + '] ' + msg;
    debugLog.appendChild(span);
    debugLog.scrollTop = debugLog.scrollHeight;
  }

  function setStatus(state, text) {
    if (!statusEl) return;
    statusEl.className = 'tryon-modal__status tryon-modal__status--' + state;
    if (statusTxt) statusTxt.textContent = text || state;
  }

  // ================================================================
  // Frame catalog
  // ================================================================
  function loadCatalog(triggerEl) {
    // Priority 1: Frames passed via the trigger button's data-tryon-frames attribute
    //    This is the per-product path (Shopify metafield TRYON.frames).
    if (triggerEl) {
      var raw = triggerEl.getAttribute('data-tryon-frames');
      if (raw && raw !== '[]') {
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            frameCatalog = parsed;
            console.log('[tryon] using per-product frame catalog (' + frameCatalog.length + ' frames from button)');
            return;
          }
        } catch(e) {
          console.warn('[tryon] failed to parse data-tryon-frames', e);
        }
      }
    }
    // Priority 2: Use embedded base64 frames (4 demo frames)
    if (typeof EMBEDDED_FRAMES !== 'undefined' && EMBEDDED_FRAMES.length > 0) {
      frameCatalog = EMBEDDED_FRAMES;
      console.log('[tryon] using embedded demo frame catalog (' + frameCatalog.length + ' frames)');
      return;
    }
    // Priority 3: Try the script tag from Liquid
    var el = document.getElementById('tryonModalFrames');
    if (el) {
      try {
        frameCatalog = JSON.parse(el.textContent);
        console.log('[tryon] using Liquid frame catalog (' + frameCatalog.length + ' frames)');
        return;
      } catch(e) {
        console.warn('[tryon] failed to parse Liquid frame catalog', e);
      }
    }
    frameCatalog = [];
    console.error('[tryon] no frame catalog available');
  }

  function buildFrameGrid() {
    if (!frameGrid) return;
    frameGrid.innerHTML = '';
    frameChips = [];
    frameCatalog.forEach(function(frame) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'tryon-modal__frame-chip';
      chip.dataset.frameKey = frame.key;
      chip.dataset.frameImage = frame.image;
      chip.dataset.frameName = frame.name;
      chip.innerHTML =
        '<img src="' + frame.image + '" alt="' + frame.name + '" loading="lazy">' +
        '<span class="tryon-modal__frame-chip-name">' + frame.name + '</span>';
      chip.addEventListener('click', function() {
        selectFrame(frame.key, frame.image, frame.name);
        closeFrameSheet();
      });
      frameGrid.appendChild(chip);
      frameChips.push(chip);
    });
  }

  // ================================================================
  // Color swatches (4-8 colors per product, rendered bottom-right)
  // ================================================================
  function renderColorSwatches() {
    if (!colorSwatchesGrid) return;
    colorSwatchesGrid.innerHTML = '';
    if (frameCatalog.length <= 1) {
      // Only 0-1 frames — hide the swatches panel entirely
      if (colorSwatchesEl) colorSwatchesEl.hidden = true;
      return;
    }
    if (colorSwatchesEl) colorSwatchesEl.hidden = false;
    frameCatalog.forEach(function(frame) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tryon-modal__swatch';
      btn.dataset.frameKey = frame.key;
      btn.dataset.frameImage = frame.image;
      btn.dataset.frameName = frame.name;
      btn.title = frame.name;
      btn.setAttribute('aria-label', 'Switch to ' + frame.name);
      btn.innerHTML = '<img src="' + frame.image + '" alt="' + frame.name + '" loading="lazy">';
      if (frame.key === activeFrameKey) btn.classList.add('is-active');
      btn.addEventListener('click', function() {
        selectFrame(frame.key, frame.image, frame.name);
        // Update active class
        colorSwatchesGrid.querySelectorAll('.tryon-modal__swatch').forEach(function(s) {
          s.classList.toggle('is-active', s === btn);
        });
        // Restart camera so the new frame is visible
        if (stream) {
          stopCamera();
          setTimeout(function() { startCamera(); }, 100);
        }
      });
      colorSwatchesGrid.appendChild(btn);
    });
  }

  // Optional callback fired after frame image finishes loading
  function selectFrame(key, imageUrl, name, onLoaded) {
    activeFrameKey = key;
    // Highlight active chip
    frameChips.forEach(function(c) {
      c.classList.toggle('is-active', c.dataset.frameKey === key);
    });
    // If image already cached and matches, just fire callback immediately
    if (currentFrame.img && currentFrame.key === key) {
      if (onLoaded) onLoaded();
      return;
    }
    loadFrame(imageUrl, name || key, key, onLoaded);
    log('frame selected: ' + key, 'ok');
  }

  // ================================================================
  // Modal open / close
  // ================================================================
  function openModal(triggerEl) {
    isOpen = true;
    screenState = 'consent';
    consentEl.hidden = false;
    stageEl.hidden   = true;
    pdPopover.hidden = true;
    if (adjustPopover) adjustPopover.hidden = false;  // always visible
    if (colorSwatchesEl) colorSwatchesEl.hidden = true; // shown after consent
    frameSheet.hidden = true;
    pdPopoverVisible = false;
    adjustPopoverVisible = true;
    frameSheetVisible = false;
    activeFrameKey = null;  // reset so first frame from new product is selected

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    log('--- MODAL OPEN (consent) ---', 'warn');
    loadCatalog(triggerEl);
    buildFrameGrid();
    renderColorSwatches();
    // Default to first frame
    if (frameCatalog.length > 0 && !activeFrameKey) {
      selectFrame(frameCatalog[0].key, frameCatalog[0].image, frameCatalog[0].name);
    }
  }

  function closeModal() {
    isOpen = false;
    screenState = 'consent';
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    stopCamera();
    log('--- MODAL CLOSED ---', 'warn');
    setTimeout(function() {
      consentEl.hidden = false;
      stageEl.hidden   = true;
    }, 300);
  }

  // ================================================================
  // Consent → Stage transition
  // ================================================================
  if (agreeBtn) {
    agreeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      agreeAndStart();
    });
  }

  function agreeAndStart() {
    screenState = 'stage';
    consentEl.hidden = true;
    stageEl.hidden   = false;

    log('--- CONSENT GIVEN → STAGE ---', 'warn');

    // Trigger camera start after DOM update
    requestAnimationFrame(function() {
      sizeCanvas();
      showStartOverlay();
    });
  }

  // ================================================================
  // Camera
  // ================================================================
  function showStartOverlay() {
    if (startOvl) startOvl.hidden = false;
    setStatus('idle', 'Ready');
  }

  var cameraSpinner = document.getElementById('tryonModalCameraSpinner');
  var startHint    = document.getElementById('tryonModalStartHint');

  function showStartOverlay(msg) {
    if (startOvl) startOvl.hidden = false;
    if (cameraSpinner) cameraSpinner.style.display = 'none';
    if (startHint) {
      startHint.textContent = msg || 'Everything runs in your browser — no video is uploaded.';
    }
  }

  function showCameraLoading() {
    if (startOvl) startOvl.hidden = false;
    if (cameraSpinner) cameraSpinner.style.display = 'block';
    if (startHint) startHint.textContent = 'Requesting camera access...';
  }

  async function startCamera() {
    log('startCamera() called', 'warn');
    console.log('[tryon] startCamera() called');

    // If frame image not yet loaded, wait for it (re-select with callback)
    if (!currentFrame.img || currentFrame.key !== activeFrameKey) {
      log('frame not ready, waiting...', 'warn');
      setStatus('loading', 'Loading frame...');
      var frameData = frameCatalog.find(function(f) { return f.key === activeFrameKey; });
      if (frameData) {
        selectFrame(frameData.key, frameData.image, frameData.name, startCamera);
      } else {
        setStatus('error', 'Frame error');
      }
      return;
    }

    showCameraLoading();
    setStatus('loading', 'Requesting camera...');

    // Check if mediaDevices API is available
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      log('mediaDevices API not available', 'err');
      console.error('[tryon] navigator.mediaDevices.getUserMedia is NOT available');
      setStatus('error', 'Camera API unavailable');
      showStartOverlay('Your browser does not support camera access. Try Chrome, Safari, or Firefox.');
      return;
    }

    // Step 1: Ask for camera permission FIRST (no MediaPipe yet)
    try {
      console.log('[tryon] calling getUserMedia...');
      stream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 1280 }, height: { ideal: 720 }, facingMode: 'user' },
        audio: false
      });
      console.log('[tryon] getUserMedia SUCCESS', stream);
      video.srcObject = stream;
      await video.play();
      sizeCanvas();
      window.addEventListener('resize', sizeCanvas);
      if (startOvl) startOvl.hidden = true;
      setStatus('active', 'Camera live');
      log('camera started', 'ok');
    } catch(err) {
      console.error('[tryon] CAMERA FAILED', err);
      log('CAMERA FAILED: ' + err.name + ': ' + err.message, 'err');
      setStatus('error', 'Camera: ' + (err.name || 'denied'));
      var errMsg = 'Camera access failed: ' + (err.message || err.name || 'unknown');
      if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        errMsg = 'Camera permission denied. Please allow camera in browser settings and try again.';
      } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
        errMsg = 'No camera found. Please connect a camera and try again.';
      } else if (err.name === 'NotReadableError') {
        errMsg = 'Camera is busy. Close other apps using the camera and try again.';
      }
      showStartOverlay(errMsg);
      return;
    }

    // Step 2: Camera is running — now load MediaPipe in background
    setStatus('loading', 'Loading model...');
    try {
      await loadFaceMesh();
    } catch(e) {
      log('MediaPipe CDN blocked — running in test mode (no face tracking)', 'err');
      setStatus('active', 'Test mode');
      showStartOverlay('Face tracking unavailable (CDN blocked). Camera is live — click to retry.');
      drawTestFrame();
      return;
    }

    // Step 3: MediaPipe loaded — enable AR tracking
    try {
      faceMesh = new window.FaceMesh({
        locateFile: function(file) {
          return 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/' + file;
        }
      });
      faceMesh.setOptions({
        maxNumFaces: 1, refineLandmarks: true,
        minDetectionConfidence: 0.3, minTrackingConfidence: 0.3
      });
      faceMesh.onResults(onResultsLive);
      log('MediaPipe ready — AR tracking active', 'ok');
      setStatus('active', 'Live');
      detectLoop();
    } catch(e) {
      log('FaceMesh init failed: ' + e.message, 'err');
      setStatus('active', 'Test mode');
      showStartOverlay('Face tracking unavailable. Camera is live.');
      drawTestFrame();
    }
  }

  function stopCamera() {
    if (detectRAF) { cancelAnimationFrame(detectRAF); detectRAF = null; }
    if (stream)    { stream.getTracks().forEach(function(t) { t.stop(); }); stream = null; }
    if (video)     { video.srcObject = null; }
    window.removeEventListener('resize', sizeCanvas);
    if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    setStatus('idle', 'Idle');
  }

  function sizeCanvas() {
    if (!canvas || !canvas.parentElement) return;
    canvas.width  = canvas.parentElement.clientWidth;
    canvas.height = canvas.parentElement.clientHeight;
    log('canvas: ' + canvas.width + 'x' + canvas.height);
  }

  async function detectLoop() {
    if (!faceMesh || !video || !video.srcObject) return;
    try {
      await faceMesh.send({ image: video });
    } catch(err) {
      if (frameCount % 60 === 0) log('send error: ' + err.message, 'err');
    }
    detectRAF = requestAnimationFrame(detectLoop);
  }

  // ================================================================
  // MediaPipe
  // ================================================================
  function loadScript(src) {
    return new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.crossOrigin = 'anonymous';
      s.onload  = function() { resolve(src); };
      s.onerror = function() { reject(new Error(src)); };
      document.head.appendChild(s);
    });
  }
  async function loadFaceMesh() {
    var cdns = [
      'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/face_mesh.js',
      'https://unpkg.com/@mediapipe/face_mesh/face_mesh.js',
      'https://cdn.bootcdn.net/ajax/libs/mediapipe/0.3.1/face_mesh.js',
      'https://cdnjs.cloudflare.com/ajax/libs/mediapipe-face_mesh/0.4/face_mesh.js'
    ];
    for (var i = 0; i < cdns.length; i++) {
      try { await loadScript(cdns[i]); log('MediaPipe: ' + cdns[i], 'ok'); return; }
      catch(e) { log('CDN fail: ' + cdns[i], 'err'); }
    }
    throw new Error('All MediaPipe CDNs failed');
  }

  // ================================================================
  // Frame loading
  // ================================================================
  function loadFrame(url, name, key, onLoaded) {
    currentFrame.key  = key || 'frame';
    currentFrame.name = name || 'Frame';
    currentFrame.img  = null;
    var img = new Image();
    img.onload = function() {
      currentFrame.img = img;
      log('frame loaded: ' + img.naturalWidth + 'x' + img.naturalHeight + ' (' + key + ')', 'ok');
      // If camera not started yet, show test render
      if (!stream) drawTestFrame();
      if (onLoaded) onLoaded();
    };
    img.onerror = function(e) {
      log('frame load FAILED: ' + url, 'err');
      setStatus('error', 'Frame load failed');
    };
    img.src = url;
  }

  function drawTestFrame() {
    if (!ctx || !currentFrame.img) return;
    var img = currentFrame.img;
    var cw = canvas.clientWidth * 0.55;
    var ch = cw * (img.naturalHeight / img.naturalWidth);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, (canvas.clientWidth - cw) / 2, (canvas.clientHeight - ch) / 2, cw, ch);
  }

  // ================================================================
  // PD
  // ================================================================
  function computePD(landmarks, W) {
    var lp = landmarks[468], rp = landmarks[473];
    var lt = landmarks[234], rt = landmarks[454];
    if (!lp || !rp || !lt || !rt) return null;
    var pupilDist = Math.hypot((rp.x - lp.x) * W, (rp.y - lp.y) * W);
    var faceWidth = Math.hypot((rt.x - lt.x) * W, (rt.y - lt.y) * W);
    if (faceWidth < 1) return null;
    var pxPerMm = faceWidth / FACE_WIDTH_MM;
    return Math.max(50, Math.min(80, pupilDist / pxPerMm));
  }
  function getActivePD() { return pdOverride !== null ? pdOverride : measuredPD; }
  function updatePDDisplay() {
    var pd = getActivePD();
    if (pdValueEl) pdValueEl.textContent = pd.toFixed(1) + ' mm';
    if (pdSliderEl) pdSliderEl.value = pd;
    var isManual = pdOverride !== null;
    if (pdStatusEl) {
      pdStatusEl.textContent = isManual ? '● manual' : '● measuring…';
    }
    // Update rail PD label
    var pdRailLabel = stageEl.querySelector('.tryon-modal__rail-label');
    if (pdRailLabel) pdRailLabel.textContent = pd.toFixed(0) + 'mm';
  }
  if (pdSliderEl) {
    pdSliderEl.addEventListener('input', function(e) {
      pdOverride = parseFloat(e.target.value);
      updatePDDisplay();
    });
  }
  if (pdResetEl) {
    pdResetEl.addEventListener('click', function() {
      pdOverride = null;
      updatePDDisplay();
      log('PD reset to auto: ' + measuredPD.toFixed(1) + 'mm', 'ok');
    });
  }

  // ================================================================
  // Adjust popover (Size / Y / X)
  // ================================================================
  if (sizeSliderEl) {
    sizeSliderEl.addEventListener('input', function(e) {
      sizeMultiplier = parseFloat(e.target.value);
      if (sizeValEl) sizeValEl.textContent = sizeMultiplier.toFixed(1) + '×';
      log('size: ' + sizeMultiplier.toFixed(1) + 'x', 'ok');
    });
  }
  if (ySliderEl) {
    ySliderEl.addEventListener('input', function(e) {
      yOffsetPct = parseInt(e.target.value, 10);
      if (yValEl) yValEl.textContent = yOffsetPct + '%';
      log('y offset: ' + yOffsetPct + '%', 'ok');
    });
  }
  if (xSliderEl) {
    xSliderEl.addEventListener('input', function(e) {
      xOffsetPct = parseInt(e.target.value, 10);
      if (xValEl) xValEl.textContent = xOffsetPct + '%';
      log('x offset: ' + xOffsetPct + '%', 'ok');
    });
  }
  if (adjustResetBtn) {
    adjustResetBtn.addEventListener('click', function() {
      sizeMultiplier = defaultSize;
      yOffsetPct = 0;
      xOffsetPct = 0;
      if (sizeSliderEl) sizeSliderEl.value = defaultSize;
      if (ySliderEl) ySliderEl.value = 0;
      if (xSliderEl) xSliderEl.value = 0;
      if (sizeValEl) sizeValEl.textContent = defaultSize.toFixed(1) + '×';
      if (yValEl) yValEl.textContent = '0%';
      if (xValEl) xValEl.textContent = '0%';
      log('adjust reset to defaults', 'ok');
    });
  }

  // ================================================================
  // Lens tabs — change tint overlay
  // ================================================================
  lensTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      activeLensType = tab.dataset.lens;
      lensTabs.forEach(function(t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      log('lens: ' + activeLensType, 'ok');
    });
  });

  // ================================================================
  // Lenses / Frames toggle
  // ================================================================
  dockPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var tab = pill.dataset.dock;
      activeDockTab = tab;
      dockPills.forEach(function(p) {
        p.classList.toggle('is-active', p === pill);
      });
      if (tab === 'frames') {
        frameSheet.hidden = false;
        frameSheetVisible = true;
      } else {
        closeFrameSheet();
      }
      log('dock tab: ' + tab, 'ok');
    });
  });

  function closeFrameSheet() {
    if (frameSheet) { frameSheet.hidden = true; frameSheetVisible = false; }
    var framesPill = stageEl.querySelector('[data-dock="frames"]');
    var lensesPill = stageEl.querySelector('[data-dock="lenses"]');
    if (framesPill) framesPill.classList.remove('is-active');
    if (lensesPill) lensesPill.classList.add('is-active');
    activeDockTab = 'lenses';
  }

  if (viewDetailsBtn) {
    viewDetailsBtn.addEventListener('click', function() {
      // Switch to frames tab and show sheet
      dockPills.forEach(function(p) { p.classList.remove('is-active'); });
      var framesPill = stageEl.querySelector('[data-dock="frames"]');
      if (framesPill) framesPill.classList.add('is-active');
      frameSheet.hidden = false;
      frameSheetVisible = true;
      activeDockTab = 'frames';
    });
  }

  var frameSheetCloseBtn = frameSheet ? frameSheet.querySelector('[data-tryon-close-sheet]') : null;
  if (frameSheetCloseBtn) {
    frameSheetCloseBtn.addEventListener('click', closeFrameSheet);
  }

  // ================================================================
  // Left rail buttons
  // ================================================================
  railBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var action = btn.dataset.tryonAction;
      log('rail action: ' + action);
      if (action === 'pd') {
        pdPopoverVisible = !pdPopoverVisible;
        if (pdPopover) pdPopover.hidden = !pdPopoverVisible;
      } else {
        // Close pd popover for other actions
        if (pdPopover) pdPopover.hidden = true;
        pdPopoverVisible = false;
      }
      if (action === 'upload' && photoInput) {
        photoInput.click();
      }
      if (action === 'reset') {
        doReset();
      }
    });
  });

  if (pdCloseBtn) {
    pdCloseBtn.addEventListener('click', function() {
      if (pdPopover) pdPopover.hidden = true;
      pdPopoverVisible = false;
    });
  }

  // ================================================================
  // Photo upload
  // ================================================================
  if (photoInput) {
    photoInput.addEventListener('change', function(e) {
      var file = e.target.files && e.target.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function(ev) {
        var img = new Image();
        img.onload = function() {
          stopCamera();
          sizeCanvas();
          if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
          var maxW = canvas.width * 0.9, maxH = canvas.height * 0.9;
          var scale = Math.min(maxW / img.width, maxH / img.height);
          var w = img.width * scale, h = img.height * scale;
          if (ctx) ctx.drawImage(img, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
          log('photo loaded: ' + img.width + 'x' + img.height, 'ok');
          runPhotoFaceMesh(img);
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
      photoInput.value = '';
    });
  }

  async function runPhotoFaceMesh(img) {
    try { await loadFaceMesh(); } catch(e) { log('model fail: ' + e.message, 'err'); return; }
    faceMesh = new window.FaceMesh({
      locateFile: function(file) { return 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/' + file; }
    });
    faceMesh.setOptions({
      maxNumFaces: 1, refineLandmarks: true,
      minDetectionConfidence: 0.3, minTrackingConfidence: 0.3
    });
    faceMesh.onResults(onResultsPhoto);
    await faceMesh.send({ image: img });
    log('photo processed', 'ok');
  }

  function onResultsPhoto(results) {
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var maxW = canvas.width * 0.9, maxH = canvas.height * 0.9;
    var scale = Math.min(maxW / results.image.width, maxH / results.image.height);
    var w = results.image.width * scale, h = results.image.height * scale;
    ctx.drawImage(results.image, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
    if (results.multiFaceLandmarks && results.multiFaceLandmarks.length > 0) {
      drawGlasses(results.multiFaceLandmarks[0]);
    }
  }

  // ================================================================
  // Draw glasses on canvas
  // ================================================================
  function drawGlasses(landmarks) {
    if (!ctx || !currentFrame.img) return;
    // v16.1 (2026-06-27): added fallbacks for mobile camera quality
    // 468/473 = pupil iris (can be null in poor lighting)
    // 33/263 = eye corner (always present)
    // 168 = nose bridge (can be null when face is tilted)
    // 2 = between eyebrows (always present)
    var leftEye  = landmarks[468] || landmarks[33];
    var rightEye = landmarks[473] || landmarks[263];
    var noseBridge = landmarks[168] || landmarks[2];
    var noseTip = landmarks[1];
    if (!leftEye || !rightEye || !noseBridge) return;

    var W = canvas.width, H = canvas.height;

    // === v16 POSITION (regenerated 2026-06-26 21:47) ===
    // Anchor: nose bridge (landmark 168) — where the frame's bridge should sit.
    // Frame size scales with pupil distance. Angle is clamped to ±2° to filter landmark jitter.
    // bridgeDrop compensates for the brow bar above the frame's geometric center.

    // Pupil distance in pixels
    var pdPx = Math.hypot(
      (rightEye.x - leftEye.x) * W,
      (rightEye.y - leftEye.y) * H
    );

    // Frame geometry: width = pupil distance × sizeMultiplier
    var gWidth  = pdPx * sizeMultiplier;
    // v16.2 (2026-06-27): mobile face is closer to camera, pdPx disproportionately large
    if (W < 600) gWidth *= 0.7;  // 30% smaller on mobile
    var gHeight = gWidth * (currentFrame.img.naturalHeight / currentFrame.img.naturalWidth);

    // Frame rotation: angle of eye line, clamped to ±2° (filters landmark jitter)
    var rawAngle = Math.atan2(
      (rightEye.y - leftEye.y) * H,
      (rightEye.x - leftEye.x) * W
    );
    if (Math.abs(rawAngle) > 0.035) rawAngle = 0;
    var angle = rawAngle;

    // Bridge drop: the frame's bridge is slightly above center (due to brow bar).
    // Offset the draw center DOWN by 15% of frame height so the bridge lands on the nose.
    var bridgeDrop = gHeight * 0.08;  // v16.1: tuned down from 0.15 → 0.08 to make glasses sit more naturally on the nose (2026-06-26 23:09)

    // Final position: anchored at nose bridge, shifted by user sliders.
    // Canvas is mirrored (scaleX(-1)), so positive xOffsetPct = visual right → subtract from cx.
    // Positive yOffsetPct = visual up → subtract from cy.
    var cx = noseBridge.x * W - (xOffsetPct / 100) * W;
    var cy = noseBridge.y * H + bridgeDrop - (yOffsetPct / 100) * H;

    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(angle);

    // Lens tint overlay (draw as filled ellipse under the frame image)
    var lensColor = LENS_COLORS[activeLensType];
    if (lensColor) {
      ctx.fillStyle = lensColor;
      ctx.beginPath();
      var lensW = gWidth * 0.42;
      var lensH = gHeight * 0.38;
      // Left lens
      ctx.ellipse(-gWidth * 0.22, 0, lensW, lensH, 0, 0, Math.PI * 2);
      ctx.fill();
      // Right lens
      ctx.beginPath();
      ctx.ellipse(gWidth * 0.22, 0, lensW, lensH, 0, 0, Math.PI * 2);
      ctx.fill();
    }

    // Frame image
    ctx.drawImage(currentFrame.img, -gWidth / 2, -gHeight / 2, gWidth, gHeight);
    ctx.restore();
  }

  // ================================================================
  // Face mesh results (live camera)
  // ================================================================
  function onResultsLive(results) {
    frameCount++;
    var hasFace = !!(results.multiFaceLandmarks && results.multiFaceLandmarks.length > 0);
    if (hasFace) faceDetectedCount++;
    if (frameCount === 1 || frameCount % 60 === 0 || (hasFace && faceDetectedCount === 1)) {
      log('frame #' + frameCount + ' | face: ' + (hasFace ? '1 OK' : '0'), hasFace ? 'ok' : '');
    }
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (hasFace && frameCount % 10 === 0) {
      var newPD = computePD(results.multiFaceLandmarks[0], canvas.width);
      if (newPD !== null && Math.abs(newPD - measuredPD) > 0.5) {
        measuredPD = newPD;
        if (pdOverride === null) updatePDDisplay();
      }
    }
    if (hasFace) drawGlasses(results.multiFaceLandmarks[0]);
  }

  // Alias
  var onResults = onResultsLive;

  // ================================================================
  // Capture
  // ================================================================
  var captureBtn = stageEl.querySelector('[data-tryon-capture]') || document.getElementById('tryonModalCaptureBtn');
  if (!captureBtn) {
    // Look for capture button in dock
    captureBtn = stageEl.querySelector('#tryonModalCaptureBtn');
  }

  // Create capture button dynamically in dock if not in HTML
  var dockEl = stageEl.querySelector('.tryon-modal__dock-bottom');
  if (dockEl && !document.getElementById('tryonModalCaptureBtn')) {
    var capBtn = document.createElement('button');
    capBtn.type = 'button';
    capBtn.id = 'tryonModalCaptureBtn';
    capBtn.className = 'tryon-modal__btn tryon-modal__btn--primary';
    capBtn.style.cssText = 'margin-left:auto;padding:7px 16px;font-size:12px;border-radius:8px;';
    capBtn.textContent = '📸 Capture';
    capBtn.disabled = true;
    capBtn.addEventListener('click', doCapture);
    dockEl.appendChild(capBtn);
    captureBtn = capBtn;
  }

  function doCapture() {
    if (!stream && !video.srcObject) return;
    var composite = document.createElement('canvas');
    composite.width  = video.videoWidth  || canvas.width;
    composite.height = video.videoHeight || canvas.height;
    var cctx = composite.getContext('2d');
    cctx.drawImage(video, 0, 0, composite.width, composite.height);
    cctx.drawImage(canvas, 0, 0, composite.width, composite.height);
    composite.toBlob(function(blob) {
      var url = URL.createObjectURL(blob);
      var a   = document.createElement('a');
      a.href   = url;
      a.download = 'irisharp-tryon-' + (activeFrameKey || 'frame') + '-' + Date.now() + '.png';
      a.click();
      setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
      log('capture saved', 'ok');
    });
  }
  if (captureBtn) {
    captureBtn.addEventListener('click', doCapture);
  }

  // ================================================================
  // Reset
  // ================================================================
  function doReset() {
    sizeMultiplier = defaultSize;
    yOffsetPct = 0;
    xOffsetPct = 0;
    pdOverride  = null;
    activeLensType = 'clear';
    // Sync adjust sliders
    if (sizeSliderEl) sizeSliderEl.value = defaultSize;
    if (ySliderEl) ySliderEl.value = 0;
    if (xSliderEl) xSliderEl.value = 0;
    if (sizeValEl) sizeValEl.textContent = defaultSize.toFixed(1) + '×';
    if (yValEl) yValEl.textContent = '0%';
    if (xValEl) xValEl.textContent = '0%';
    lensTabs.forEach(function(t) {
      t.classList.toggle('is-active', t.dataset.lens === 'clear');
      t.setAttribute('aria-selected', t.dataset.lens === 'clear' ? 'true' : 'false');
    });
    updatePDDisplay();
    closeFrameSheet();
    if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (currentFrame.img && !stream) drawTestFrame();
    log('reset to defaults', 'ok');
  }

  // ================================================================
  // Start button
  // ================================================================
  if (startBtn) {
    startBtn.addEventListener('click', function() {
      startCamera();
    });
  }

  // ================================================================
  // Debug
  // ================================================================
  if (debugToggle) {
    debugToggle.addEventListener('click', function() {
      if (debugLog) debugLog.hidden = !debugLog.hidden;
    });
  }

  // ================================================================
  // Global trigger listener
  // ================================================================
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-tryon-trigger]');
    if (trigger && !isOpen) {
      e.preventDefault();
      openModal(trigger);
      return;
    }
    // Close on backdrop or close button
    if (e.target.closest('[data-tryon-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeModal();
  });

  // ================================================================
  // Initialize
  // ================================================================
  updatePDDisplay();
  loadCatalog();
  buildFrameGrid();
  log('Try-On Modal ready', 'ok');

})();
